module.exports = __webpack_public_path__ + "static/media/wave-line-vertical.c758bb2b.svg";